import { sanitizeAnchor } from './routeAnchor';
import type { RouteStop, StoredRoute } from './types';
import { coordinatesFresh, GOOGLE_EXPIRED, GOOGLE_PLACEHOLDER } from './placesRetention';

/** Legacy Google copies have no proven coordinate clock; saving them never renews it. */
export const sanitizeStop = (stop: RouteStop, now = new Date()): RouteStop => {
  const independent = /^(roster|lead|signal):/.exec(stop.place_id)?.[1] as RouteStop['source'];
  if (independent || (stop.source === 'lead' && stop.lead_id) || (stop.signal_id && stop.source !== 'google'))
    return { ...stop, source: independent ?? (stop.lead_id && stop.source === 'lead' ? 'lead' : 'signal') };
  const fresh = coordinatesFresh(stop.coordinates_at, now) && stop.lat !== null && stop.lng !== null;
  // Whitelist: unknown legacy detail fields cannot hide in route JSON.
  return {
    place_id: stop.place_id, source: 'google', name: fresh ? GOOGLE_PLACEHOLDER : GOOGLE_EXPIRED,
    address: null, types: [], lat: fresh ? stop.lat : null, lng: fresh ? stop.lng : null,
    detected_pos: stop.detected_pos, location_expired: !fresh,
    ...(stop.coordinates_at ? { coordinates_at: stop.coordinates_at } : {}),
    ...(stop.lead_id ? { lead_id: stop.lead_id } : {}),
    ...(stop.signal_id ? { signal_id: stop.signal_id } : {}),
    ...(stop.note ? { note: stop.note } : {}),
    ...(stop.arrive ? { arrive: stop.arrive } : {}),
    ...(stop.meeting !== undefined ? { meeting: stop.meeting } : {}),
  };
};
export const sanitizeRoute = (route: StoredRoute, now = new Date()): StoredRoute => ({
  ...route, anchor: sanitizeAnchor(route.anchor, now), stops: route.stops.map((s) => sanitizeStop(s, now)),
});
export const locatedStop = (s: RouteStop): s is RouteStop & { lat: number; lng: number } =>
  typeof s.lat === 'number' && typeof s.lng === 'number' && !s.location_expired;
